export default {
  SET (state, data) {
    if (data?.user) {
      state.loggedIn.id = data.user.id
      state.loggedIn.alarmEmails = data.user.alarmEmails
      state.loggedIn.email = data.user.email
      state.loggedIn.allOrganizations = data.user.allOrganizations
      state.loggedIn.isIntegrator = data.user.isIntegrator
      state.loggedIn.integrator = data.user.integrator
      state.loggedIn.firstName = data.user.firstName
      state.loggedIn.lastName = data.user.lastName
      state.loggedIn.mobilePhone = data.user.mobilePhone
      if (data.permissions) {
        state.permissions = data.permissions
      }
      if (data.groupIds) {
        state.groupIds = data.groupIds
      }
      if (data.orgIds) {
        state.orgIds = data.orgIds
      }
      state.authenticated = state.loggedIn.id !== null
    } else {
      state.loggedIn.id = ''
      state.loggedIn.alarmEmails = false
      state.loggedIn.email = ''
      state.loggedIn.allOrganizations = false
      state.loggedIn.isIntegrator = false
      state.loggedIn.integrator = ''
      state.loggedIn.firstName = ''
      state.loggedIn.lastName = ''
      state.loggedIn.mobilePhone = ''
      state.orgIds = []
      state.groupIds = []
      state.permissions = {}
      state.authenticated = false
    }
  },
  RESET (state) {
    state.loggedIn.id = ''
    state.loggedIn.alarmEmails = false
    state.loggedIn.email = ''
    state.loggedIn.allOrganizations = false
    state.loggedIn.isIntegrator = false
    state.loggedIn.firstName = ''
    state.loggedIn.lastName = ''
    state.loggedIn.mobilePhone = ''
    state.orgIds = []
    state.groupIds = []
    state.permissions = {}
    state.authenticated = false
  },
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        alarmEmails: value.alarmEmails,
        email: value.email,
        firstName: value.firstName,
        lastName: value.lastName,
        mobilePhone: value.mobilePhone,
        isIntegrator: value.isIntegrator,
        branch: value.branch
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        alarmEmails: value.alarmEmails,
        email: value.email,
        firstName: value.firstName,
        lastName: value.lastName,
        mobilePhone: value.mobilePhone,
        allOrganizations: value.allOrganizations,
        isIntegrator: value.isIntegrator,
        branch: value.branch,
        groups: value.groups.length,
        organizations: value.organizations.length
      })
    }
  },
  CURRENT (state, value) {
    if (value) {
      state.current = value
    } else {
      state.current = {
        id: '',
        alarmEmails: false,
        email: '',
        allOrganizations: false,
        isIntegrator: false,
        firstName: '',
        lastName: '',
        mobilePhone: '',
        branch: '',
        group: '',
        organizations: []
      }
    }
    state.update.active = state.current.active
    state.update.alarmEmails = state.current.alarmEmails
    state.update.email = state.current.email
    state.update.allOrganizations = state.current.allOrganizations
    state.update.isIntegrator = state.current.isIntegrator
    state.update.firstName = state.current.firstName
    state.update.lastName = state.current.lastName
    state.update.mobilePhone = state.current.mobilePhone
    state.update.group = state.current.group
    state.update.branch = state.current.branch
  },
  UPDATE_ACTIVE (state, value) {
    state.update.active = value
  },
  UPDATE_EMAIL (state, value) {
    state.update.email = value
  },
  UPDATE_ALARM_EMAILS (state, value) {
    state.update.alarmEmails = value
  },
  UPDATE_ALLORGANIZATIONS (state, value) {
    state.update.allOrganizations = value
  },
  UPDATE_BRANCH (state, value) {
    state.update.branch = value
  },
  UPDATE_GROUP (state, value) {
    state.update.group = value
  },
  UPDATE_IS_INTEGRATOR (state, value) {
    state.update.isIntegrator = value
  },
  UPDATE_FIRSTNAME (state, value) {
    state.update.firstName = value
  },
  UPDATE_LASTNAME (state, value) {
    state.update.lastName = value
  },
  UPDATE_MOBILEPHONE (state, value) {
    state.update.mobilePhone = value
  },
  UPDATE_LOGGEDIN_ALARM_EMAILS (state, value) {
    state.updateLoggedIn.alarmEmails = value
  },
  UPDATE_LOGGEDIN_EMAIL (state, value) {
    state.updateLoggedIn.email = value
  },
  UPDATE_LOGGEDIN_FIRSTNAME (state, value) {
    state.updateLoggedIn.firstName = value
  },
  UPDATE_LOGGEDIN_LASTNAME (state, value) {
    state.updateLoggedIn.lastName = value
  },
  UPDATE_LOGGEDIN_MOBILEPHONE (state, value) {
    state.updateLoggedIn.mobilePhone = value
  },
  UPDATE_LOGGEDIN_PASSWORD (state, value) {
    state.updateLoggedIn.password = value
  },
  ADD_ORGANIZATION (state, value) {
    state.current.organizations.push(value)
  },
  REMOVE_ORGANIZATION (state, value) {
    const index = state.current.organizations.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.current.organizations.splice(index, 1)
    }
  },
  UPDATE_ORGANIZATION (state, value) {
    const index = state.current.organizations.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.current.organizations.splice(index, 1, value)
    }
  }
}
